import { useSelector } from 'react-redux';

import { getVisitsPagination } from '../../selectors';

const usePagination = () => useSelector(getVisitsPagination);

export default usePagination;
